import { FilterOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import type { Dayjs } from "dayjs";
import {
  Form,
  Input,
  InputNumber,
  Button,
  Select,
  type FormProps,
  Flex,
  theme,
} from "antd";
import { useCallback, useEffect, useMemo, useState } from "react";
import { CrudFilters } from "@refinedev/core";
import { useLocalStorage } from "@/hooks/useLocalStorage";
import { getStatuses } from "@/utilities";
import { useTranslation } from "react-i18next";

const getSellerStatus = (t: any) => [
  {
    label: t("filter.products.labelStatusActive"),
    value: "active",
  },
  {
    label: t("filter.products.labelStatusPausedBySeller"),
    value: "paused_by_seller",
  },
  {
    label: t("filter.products.labelStatusPausedByStore"),
    value: "paused_by_store",
  },
  {
    label: t("filter.products.labelStatusPausedByStore&Seller"),
    value: "paused_by_store_and_seller",
  },
];

const getLinkStatus = (t: any) => [
  {
    label: t("filter.products.optionLinked"),
    value: 1,
  },
  {
    label: t("filter.products.optionUnlinked"),
    value: 0,
  },
];

const getRequestStatus = (t: any) => [
  {
    label: t("table.linkedsellers.description.requestsent"),
    value: "store",
  },
  {
    label: t("table.linkedsellers.description.requestreceived"),
    value: "seller",
  },
];

export const LinkedSellersFilters: React.FC<{
  searchFormProps: FormProps;
  filters?: CrudFilters;
  t?: any;
}> = ({ searchFormProps, filters, t }) => {
  const { t: tHook } = useTranslation();
  const translate = t || tHook;
  const [calendarValue, setCalendarValue] = useState<any>();
  const [showRangePicker, setShowRangePicker] = useState(false);
  const [radioValue, setRadioValue] = useLocalStorage<any>("RadioCalendar", []);
  const [radioValueCreated, setRadioValueCreated] = useLocalStorage<any>(
    "RadioCalendarCreated",
    [],
  );

  const STATUSES = getStatuses(translate);

  const { token } = theme.useToken();

  function clearFilters() {
    searchFormProps.form?.resetFields();
    setCalendarValue(undefined);
    setRadioValue("");
    setRadioValueCreated("");
    setShowRangePicker(false);
    searchFormProps.form?.submit();
  }

  return (
    <Form layout="vertical" {...searchFormProps} style={{ display: "flex", flexDirection: "column", flex: 1, overflow: "hidden" }}>
      <div style={{ flex: 1, overflowY: "auto", padding: "16px 24px" }}>
      <Form.Item
        label={
          <span style={{ color: token.colorTextTertiary }}>Estado del Seller</span>
        }
        name="sellerStatus"
      >
        <Flex vertical>
          <Select
            allowClear
            placeholder={translate("filter.calendar.all")}
            options={getSellerStatus(translate)?.map((option: any) => ({
              label: option.label as string,
              value: option.value as string,
            }))}
            defaultValue={
              // @ts-expect-error Ant Design Icon's v5.0.1 has an issue with @types/react@^18.2.66
              filters?.find((f) => f.field === "quoteSellers.sellerStatus")
                ?.value
            }
            onChange={(value) => {
              searchFormProps.form?.setFieldsValue({ sellerStatus: value });
            }}
          />
        </Flex>
      </Form.Item>

      <Form.Item
        label={<span style={{ color: token.colorTextTertiary }}>Asociación</span>}
        name="linkStatus"
      >
        <Flex vertical>
          <Select
            allowClear
            placeholder={translate("filter.calendar.all")}
            options={getLinkStatus(translate)?.map((option: any) => ({
              label: option.label as string,
              value: option.value as string,
            }))}
            defaultValue={
              filters?.find(
                // @ts-expect-error Ant Design Icon's v5.0.1 has an issue with @types/react@^18.2.66
                (f) => f.field === "storeLinkedSellers.active",
              )?.value
            }
            onChange={(value) => {
              searchFormProps.form?.setFieldsValue({ linkStatus: value });
            }}
          />
        </Flex>
      </Form.Item>

      <Form.Item
        label={<span style={{ color: token.colorTextTertiary }}>Solicitud</span>}
        name="requestStatus"
      >
        <Flex vertical>
          <Select
            allowClear
            placeholder={translate("filter.calendar.all")}
            options={getRequestStatus(translate)?.map((option: any) => ({
              label: option.label as string,
              value: option.value as string,
            }))}
            defaultValue={
              filters?.find(
                // @ts-expect-error Ant Design Icon's v5.0.1 has an issue with @types/react@^18.2.66
                (f) => f.field === "storeLinkedSellerRequests.active",
              )?.value
            }
            onChange={(value) => {
              searchFormProps.form?.setFieldsValue({ requestStatus: value });
            }}
          />
        </Flex>
      </Form.Item>

      </div>
      <Flex
        align="center"
        justify="end"
        gap="8px"
        style={{ flexShrink: 0, padding: "12px 24px", borderTop: "1px solid #f0f0f0", backgroundColor: "#fff" }}
      >
        <Button type="default" danger onClick={clearFilters}>
          {translate("filter.button.clearFilters")}
        </Button>
        <Button htmlType="submit" type="primary" icon={<FilterOutlined />}>
          {translate("filter.button.filter")}
        </Button>
      </Flex>
    </Form>
  );
};
